import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../styles/CustomAlertStyle.css";
import tapImg from "../assets/images/assessment/assessment_popup_tab.png";
import bgImg from "../assets/images/assessment/assessment_popup_bg.jpg";
import arrowImg from "../assets/images/assessment/arrowImg.png";
import MultiUserWarning from "../assets/images/sessionEnded.svg";
import MultiUserLogout from "../assets/images/activeSessionLogout.svg";
import startsAt from "../assets/images/calender/sand-clock-starts.png";
import endsAt from "../assets/images/calender/sand-clock-ends.png";
import sessionClock from "../assets/images/calender/session_clock.png";
import sessionurl from "../assets/images/calender/session_url.png";
import sessionpass from "../assets/images/calender/session_pass.png";
import clockIcon from "../assets/images/calender/clock 1.png";
import crossImg from "../assets/images/errorImg.png";
import successCrossImg from "../assets/images/successImg.png";
import confirmImg from "../assets/images/confirmImg.png";
import infoImg from "../assets/images/infoImg.png";
import warningImg from "../assets/images/warningimg.png";
import closeIcon from "../assets/images/crossCloseicon.png"

interface CurriculumItem {
  sub_category_id: string;
  sub_category_name: string;
  category_id: string;
  category_name: string;
  score_per_correct_answer: number;
  score_per_wrong_answer: number;
  count: number;
  weight?: number;
  difficulty_distribution?: string;
  difficulty_count?: any;
}
interface CategoryItemData {
  category_id: "b265deed-dd0b-46d2-8cd3-16888ffe9892";
  category_name: "Test Difficulty level";
  score_per_correct_answer: 1;
  score_per_wrong_answer: 0;
  count: 2;
  weight: 0;
  difficulty_distribution: "Equal";
  difficulty_count: any;
  programming_languages?: string;
}
interface CommonAlertProps {
  title: string;
  message: string;
  assetSrc?: string;
  multipleLoginProp?: "Session_Ended" | "Session_Detected";
  button1Text?: string;
  button2Text?: string;
  btn1onPressed?: () => void;
  btn2onPressed?: () => void;
  startAssessmentPressed?: () => void;
  isNeedBackgroundPopUp?: boolean;
  onlyNeedOneButton?: boolean;
alertType?:
  | "success"
  | "error"
  | "confirmation"
  | "warning"
  | "info";
  show: boolean;
  onClose: () => void;
  identity?: string;
  bottomHintText?: string;
  deviceDetails?: string[];
  status: string;
  eventTitle: string;
  eventDesc: string;
  offset: number;
  eventDuration: string;
  assessment_duration?: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  number_of_dimension_questions: number;
  dimension_descriptive_questions: number;
  sessionUrl?: string;
  sessionPass?: string;
  curriculum_list?: CurriculumItem[];
  category_list?: CategoryItemData[];
  isExpiredProgram?: boolean;
  events: string;
  duration: string;
  eventType: string;
}

const CommonAlert: React.FC<CommonAlertProps> = ({
  title,
  message,
  assetSrc,
  multipleLoginProp,
  button1Text = "Yes",
  button2Text = "No",
  btn1onPressed,
  btn2onPressed,
  startAssessmentPressed,
  isNeedBackgroundPopUp = false,
  onlyNeedOneButton = false,
  alertType,
  show,
  identity,
  onClose,
  bottomHintText,
  deviceDetails,
  status,
  eventTitle,
  eventDesc,
  sessionUrl,
  sessionPass,
  start_date,
  end_date,
  end_time,
  start_time,
  assessment_duration,
  number_of_dimension_questions,
  dimension_descriptive_questions,
  offset,
  events,
  duration,
  eventType,
  category_list,

  isExpiredProgram = false,
}) => {
  const titleColor = alertType === "error" ? "#D43345" : "#044472";
const defaulttitleColor =
  alertType === "error"
    ? "#D43345"
    : alertType === "confirmation"
    ? "#006cb9"
    : alertType === "warning"
    ? "#7b111c"
    : alertType === "info"
    ? "#a78903"
    : "#02cc8c"; 
     const buttonColor = alertType === "error" ? "#D31309" : "#044472";
    const buttonBorderColor =  alertType === "error"
    ? "2px solid #D43345"
    : alertType === "confirmation"
    ? "2px solid #006CB9"
    : alertType === "warning"
    ? "2px solid #7B101C"
    : alertType === "info"
    ? "2px solid #A78903"
    : "2px solid #02CC8Ec"; 
  const yellowButtonColor = "#FFC85D";
  // Inside your component
  const [copiedUrl, setCopiedUrl] = useState(false);
  const [copiedPass, setCopiedPass] = useState(false);

  const copyToClipboard = (text: any, type: any) => {
    navigator.clipboard.writeText(text).then(() => {
      if (type === "url") {
        setCopiedUrl(true);
        setTimeout(() => setCopiedUrl(false), 2000);
      } else {
        setCopiedPass(true);
        setTimeout(() => setCopiedPass(false), 2000);
      }
    });
  };
  if (identity == "tabChange") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal-confirmation"
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          style={{
            backgroundColor: "#D40E0E",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <Modal.Title style={{ color: "#FFF", textAlign: "center" }}>
            {/* {title} */}Alert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            margin: "0",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            backgroundImage: `url(${bgImg})`, // Replace with your image URL
            backgroundSize: "cover", // Ensure the image covers the entire background
            backgroundRepeat: "no-repeat", // Prevent the image from repeating
            backgroundPosition: "center", // Center the image
          }}
        >
          {assetSrc && <img src={assetSrc} alt="Alert" />}
          <center>
            <img
              src={tapImg} // Replace with your image URL
              alt="description" // Add alt text for accessibility
              style={{ width: "400px", height: "100px", marginBottom: "10px" }} // Adjust size and margin as needed
            />
            <p
              style={{
                textAlign: "center",
                color: "#353535",
                fontFamily: "Mazzard",
                fontSize: "20px",
                fontWeight: "400",
              }}
            >
              {/* {message} */} Your assessment will be invalidated if you tab
              out or close the browser. Please make sure that you are on the
              assessment screen.
            </p>
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {onlyNeedOneButton ? (
            <Button
              style={{
                backgroundColor: buttonColor,
                borderColor: buttonColor,
                width: "280px ",
                color: "#ffff",
                fontFamily: "Mazzard",
                fontSize: "20px",
                fontWeight: "400",
              }}
              onClick={btn1onPressed || onClose}
            >
              Go to assessment{" "}
              <img
                src={arrowImg}
                alt="Arrow"
                style={{
                  width: "40px", // Adjust the size of the arrow image as needed
                  height: "20px", // Ensure the height is consistent with the width
                  marginLeft: "10px", // Add some space between the text and the image
                }}
              />
            </Button>
          ) : (
            <>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  borderColor: buttonColor,
                  width: "100px ",
                }}
                onClick={btn1onPressed || onClose}
              >
                {button1Text}
              </Button>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  borderColor: buttonColor,
                  width: "100px ",
                }}
                onClick={btn2onPressed || onClose}
              >
                {button2Text}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  } else if (identity === "Confirmation") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal-confirmation"
        dialogClassName="custom-modal-dialog"
        style={{ fontFamily: "Mazzard", zIndex: 9999 }}
      >
        <Modal.Header
          style={{
            backgroundColor: titleColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "55px",
            fontFamily: "Mazzard",
          }}
        >
          <Modal.Title
            style={{
              color: "#FFF",
              textAlign: "center",
              fontFamily: "Mazzard",
              fontWeight: "500",
              fontSize: "20px",
            }}
          >
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>
            <p
              style={{
                color: "#2D2D2D",
                textAlign: "center",
                fontFamily: "Mazzard",
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              {message}
            </p>
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
            paddingTop: "0px",
          }}
        >
          <>
            <Button
              style={{
                backgroundColor: "#FFC85D",
                borderColor: "#FFf",
                color: "#1A1F24",
                width: "100px ",
                fontFamily: "Mazzard",
                fontWeight: "500",
                fontSize: "18px",
                borderRadius: "8px",
                marginRight: "10px",
              }}
              onClick={btn1onPressed || onClose}
            >
              {button1Text}
            </Button>
            <Button
              style={{
                backgroundColor: "#CACACA",
                borderColor: "#FFf",
                color: "#1A1F24",
                width: "100px ",
                fontFamily: "Mazzard",
                fontWeight: "500",
                fontSize: "18px",
                borderRadius: "8px",
              }}
              onClick={btn2onPressed || onClose}
            >
              {button2Text}
            </Button>
          </>
        </Modal.Footer>
      </Modal>
    );
  }
  //Multi Login detection Alert popup
  else if (identity === "multiuser-warning") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-multiLogin"
        dialogClassName="custom-modal-multiLogin"
      >
        <Modal.Header
          style={{
            backgroundColor: titleColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <Modal.Title className="multiuser-warn-title">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            margin: "0",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <center>
            {multipleLoginProp && (
              <div>
                <img
                  src={
                    multipleLoginProp === "Session_Ended"
                      ? MultiUserWarning
                      : MultiUserLogout
                  }
                  alt="logoutSession"
                  style={{
                    height: "55px",
                    width: "55px",
                  }}
                />
                <p
                  className="multiuser-warn-redtitle"
                  style={{ paddingTop: "8px" }}
                >
                  {multipleLoginProp === "Session_Ended"
                    ? "Session Ended"
                    : " Other Session Detected"}
                </p>
              </div>
            )}

            {multipleLoginProp && (
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    wordBreak: "break-word",
                    maxWidth: "100%",
                    display: "inline-block",
                    padding: "10px 0px",
                  }}
                  className="multiuser-warn-lightgrey"
                  dangerouslySetInnerHTML={{
                    __html: message.replace(
                      /<b>(.*?)<\/b>/g,
                      `<span classname="multiuser-warn-darkgrey">$1</span>`,
                    ),
                  }}
                />
                {deviceDetails && deviceDetails.length > 0 && (
                  <div className="multiuser-devicediv">
                    <p className="multiuser-warn-bolddark">Previous Session:</p>
                    {deviceDetails.map((device, index) => (
                      <div className="multiuser-device-row" key={index}>
                        <p className="multiuser-warn-lightdark">
                          {index === 0
                            ? "Device:"
                            : index === 1
                              ? "Approx. Location:"
                              : "Login Time:"}
                        </p>
                        <p className="multiuser-warn-bolddark">{device}</p>
                      </div>
                    ))}
                  </div>
                )}

                {bottomHintText && (
                  <p
                    className="multiuser-warn-lightgrey "
                    style={{ paddingTop: "10px", marginBottom: "-10px" }}
                    dangerouslySetInnerHTML={{
                      __html: bottomHintText.replace(
                        /<b>(.*?)<\/b>/g,
                        `<span class="multiuser-warn-darkgrey">$1</span>`,
                      ),
                    }}
                  ></p>
                )}
              </div>
            )}
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <>
            <Button
              style={{
                backgroundColor: "#FFC85D",
                borderColor: "#FFC85D",
                width: "170px",
                height: "55px",
                color: "#272727",
                whiteSpace: "normal",
                wordBreak: "break-word",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 10px",
                fontSize: "16px",
                fontFamily: "Mazzard",
                fontWeight: 500,
              }}
              onClick={() => {
                btn1onPressed && btn1onPressed();
                onClose();
              }}
            >
              {button1Text}
            </Button>
            {button2Text !== "" && (
              <Button
                style={{
                  backgroundColor: "#CACACA",
                  borderColor: "#CACACA",
                  width: "170px",
                  color: "#272727",
                  fontSize: "16px",
                  fontFamily: "Mazzard",
                  fontWeight: 500,
                  height: "55px",
                }}
                onClick={() => {
                  btn2onPressed && btn2onPressed();
                  onClose();
                }}
              >
                {button2Text}
              </Button>
            )}
          </>
        </Modal.Footer>
      </Modal>
    );
  } else if (identity === "default") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal"
        dialogClassName="custom-modal-dialog"
      >
        {/* <iframe
        src="https://fast.com" // Example: Internet speed test site
        width="100%"
        height="300"
        style={{ border: "none", marginTop: "10px" }}
        title="Internet Speed Test"
      /> */}
        <Modal.Header
          style={{
            backgroundColor: titleColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <Modal.Title style={{ color: "#FFF", textAlign: "center" }}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            margin: "0",
            justifyContent: "center",
            alignItems: "center",

            textAlign: "center",
          }}
        >
          {assetSrc && <img src={assetSrc} alt="Alert" />}
          <center>
            <div
              style={{
                textAlign: "center",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontFamily: "Mazzard",
                  wordBreak: "break-word",
                  maxWidth: "100%",
                  display: "inline-block",
                }}
              >
                {message}
              </span>
            </div>
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {onlyNeedOneButton ? (
            <Button
              style={{
                backgroundColor: buttonColor,
                borderColor: buttonColor,
                width: "100px ",
              }}
              onClick={btn1onPressed || onClose}
            >
              {button1Text}
            </Button>
          ) : (
            <>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  borderColor: buttonColor,
                  width: "100px ",
                }}
                onClick={btn1onPressed || onClose}
              >
                {button1Text}
              </Button>
              <Button
                style={{
                  backgroundColor: buttonColor,
                  borderColor: buttonColor,
                  width: "auto",
                  whiteSpace: "none",
                }}
                onClick={btn2onPressed || onClose}
              >
                {button2Text}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  } else if (identity === "browserDetection") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal"
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          style={{
            backgroundColor: titleColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <Modal.Title style={{ color: "#FFF", textAlign: "center" }}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            margin: "0",
            justifyContent: "center",
            alignItems: "center",

            textAlign: "center",
          }}
        >
          {assetSrc && <img src={assetSrc} alt="Alert" />}
          <center>
            <div
              style={{
                textAlign: "center",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontFamily: "Mazzard",
                  wordBreak: "break-word",
                  maxWidth: "100%",
                  display: "inline-block",
                }}
              >
                {message}
              </span>
            </div>
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {onlyNeedOneButton === true && (
            <Button
              style={{
                backgroundColor: buttonColor,
                borderColor: buttonColor,
                width: "100px ",
              }}
              onClick={btn1onPressed || onClose}
            >
              {button1Text}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  } else if (identity === "eventDetails") {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal-eventdetails"
        dialogClassName="custom-modal-dialog-event"
      >
        <Modal.Header
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            borderBottom: "none",
            paddingBottom: "0",
            marginBottom: "0",
          }}
        >
          <Modal.Title
            style={{
              display: "flex", // Make the container a flexbox
              justifyContent: "space-between", // Distribute space between title and buttons
              alignItems: "center", // Vertically center the elements
              width: "100%", // Make sure the container takes full width
              color: "#303134",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Mazzard",
              padding: "0",
              margin: "0",
            }}
          >
            <span>{title}</span>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                backgroundColor: "#B4DEFC",
                color: "black",
                borderRadius: "5px",
                height: "40px",
                width: "40px",
                textAlign: "center",
                alignContent: "center",
                fontSize: "25px",
                fontWeight: "500",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={btn1onPressed || onClose}
            >
              X
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            paddingTop: "0",
            marginTop: "0",
            paddingBottom: "0",
            marginBottom: "0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <span
              className="eventTitleTxt"
              style={{
                color:
                  title === "LIVE_SESSION"
                    ? "#8924B9"
                    : title === "PROGRAM_KICKOFF"
                      ? "#09BD3C"
                      : title === "JOZUNA_ASSESSMENT" ||
                          title === "CURRICULUM_ASSESSMENT"
                        ? "#ED8627"
                        : "#0A68AC",
              }}
            >
              {eventTitle}
            </span>
          </div>
          <p className="descStyle">{eventDesc}</p>

          <div
            style={{
              display: "flex",
              gap: "5px",
              marginTop: "10px",
            }}
          >
            {/* {![
              "JOZUNA_ASSESSMENT",
              "CURRICULUM_ASSESSMENT",
              "LIVE_SESSION",
              "PROGRAM_KICKOFF",
            ].includes(title) && (
              <>
                <img
                  alt="Clock Icon"
                  src={flagIcon}
                  className="eventClockNextweekicon"
                />
                <p className="durationTxt">No. of Events:</p>
                <p className="durationTxt" style={{ fontWeight: 700 }}>
                  {events}
                </p>

                <img
                  alt="Clock Icon"
                  src={clockIcon}
                  className="eventClockNextweekicon"
                />
                <p className="durationTxt">Duration:</p>
                <p className="durationTxt" style={{ fontWeight: 700 }}>
                  {duration}
                </p>
              </>
            )} */}

            <img
              alt="Clock Icon"
              src={startsAt}
              className="eventClockNextweekicon"
            />
            <p className="durationTxt">Starts at:</p>
            <p className="durationTxt" style={{ fontWeight: 700 }}>
              {`${start_date || ""} | ${start_time || ""}`}
            </p>

            <img
              alt="Clock Icon"
              src={endsAt}
              className="eventClockNextweekicon"
            />
            <p className="durationTxt">Ends by:</p>
            <p className="durationTxt" style={{ fontWeight: 700 }}>
              {`${end_date || ""} | ${end_time || ""}`}
            </p>

            {["JOZUNA_ASSESSMENT", "CURRICULUM_ASSESSMENT"].includes(title) &&
              assessment_duration && (
                <>
                  <img
                    alt="Clock Icon"
                    src={clockIcon}
                    className="eventClockNextweekicon"
                  />
                  <p className="durationTxt">Assessment Duration (hh:mm):</p>
                  <p className="durationTxt" style={{ fontWeight: 700 }}>
                    {assessment_duration}
                  </p>
                </>
              )}
          </div>

          {/*  live session */}

          {title === "LIVE_SESSION" && (!sessionUrl || !sessionPass) && (
            <div
              style={{
                display: "flex",
                gap: "5px",
                marginTop: "10px",
              }}
            >
              <img
                alt="session clock"
                src={sessionClock}
                className="eventClockNextweekicon"
              />
              <p className="sessionUpdateTxt">
                {!sessionUrl && !sessionPass
                  ? "Session URL and password are not updated"
                  : !sessionUrl
                    ? "Session URL is not updated"
                    : "Session password is not updated"}
              </p>
            </div>
          )}

          {/* live session url shown */}
          {/* {sessionUrl && sessionPass && title === "LIVE_SESSION" && (
            <div
              style={{
                display: "flex",
                gap: "5px",
                marginTop: "10px",
              }}
            >
              <img
                alt="session url"
                src={sessionurl}
                className="eventClockNextweekicon"
              />
              <p className="durationTxt">Session Url:</p>
              <p className="sessionUrlTxt">{sessionUrl}</p>
              <p className="sessionUrlTxt">Copy Url</p>

              <img
                alt="session clock"
                src={sessionpass}
                className="eventClockNextweekicon"
              />
              <p className="durationTxt">Session Password:</p>
              <p className="sessionPassTxt">{sessionPass}</p>
              <p className="sessionUrlTxt">Copy Password</p>
            </div>
          )} */}
          {sessionUrl && sessionPass && title === "LIVE_SESSION" && (
            <div
              style={{
                display: "flex",
                gap: "5px",
                marginTop: "10px",
                alignItems: "center",
              }}
            >
              <img
                alt="session url"
                src={sessionurl}
                className="eventClockNextweekicon"
              />
              <p className="durationTxt">Session Url:</p>
              <p className="sessionUrlTxt">{sessionUrl}</p>
              <p
                className="sessionUrlTxt"
                style={{
                  cursor: "pointer",
                  color: copiedUrl ? "green" : "#099EF1",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  textDecoration: "underline",
                }}
                onClick={() => copyToClipboard(sessionUrl, "url")}
              >
                {copiedUrl ? (
                  <>
                    <span>✓ Copied</span>
                  </>
                ) : (
                  "Copy Link"
                )}
              </p>

              <img
                alt="session clock"
                src={sessionpass}
                className="eventClockNextweekicon"
              />
              <p className="durationTxt">Session Password:</p>
              <p className="sessionPassTxt">{sessionPass}</p>
              <p
                className="sessionUrlTxt"
                style={{
                  cursor: "pointer",
                  color: copiedPass ? "green" : "#099EF1",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  textDecoration: "underline",
                }}
                onClick={() => copyToClipboard(sessionPass, "pass")}
              >
                {copiedPass ? (
                  <>
                    <span>✓ Copied</span>
                  </>
                ) : (
                  "Copy Password"
                )}
              </p>
            </div>
          )}

          {["JOZUNA_ASSESSMENT"].includes(title) && (
            <div className="table-container">
              <table className="score-table">
                <thead>
                  <tr>
                    <th>Objective Question Count</th>
                    <th>Descriptive Question Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        style={{
                          backgroundColor: "#f6f6f6",
                          padding: "10px",
                          borderRadius: "10px",
                          fontFamily: "Mazzard",
                        }}
                      >
                        {number_of_dimension_questions}
                      </div>
                    </td>
                    <td>
                      <div className="cellstyle">
                        {dimension_descriptive_questions}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {["CURRICULUM_ASSESSMENT"].includes(title) &&
            category_list!.length > 0 && (
              <div className="table-container">
                <table className="score-table">
                  <thead>
                    <tr>
                      <th>Module</th>
                      <th>Programming</th>

                      <th>Question Count</th>
                      <th>Difficulty Distribution</th>
                      <th>Scoring Scheme</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category_list!.map((row, index) => (
                      <tr key={index}>
                        <td>
                          <div
                            style={{
                              backgroundColor: "#f6f6f6",
                              padding: "10px",
                              borderRadius: "10px",
                              fontFamily: "Mazzard",
                            }}
                          >
                            {row.category_name}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              backgroundColor: "#f6f6f6",
                              padding: "10px",
                              borderRadius: "10px",
                              fontFamily: "Mazzard",
                            }}
                          >
                            {row.programming_languages !== ""
                              ? row.programming_languages
                              : ""}
                          </div>
                        </td>

                        <td>
                          <div className="cellstyle">{row.count}</div>
                        </td>
                        <td>
                          {row.difficulty_count !== null && (
                            <div className="cellstyle">
                              Easy={row.difficulty_count.easy}, Medium=
                              {row.difficulty_count.medium}, Hard=
                              {row.difficulty_count.hard}
                            </div>
                          )}
                          {row.difficulty_count === null && (
                            <div className="cellstyle">
                              Easy=0, Medium=0, Hard=0
                            </div>
                          )}
                        </td>
                        <td>
                          <div className="cellstyle">
                            Right answer={row.score_per_correct_answer}, Wrong
                            answer={row.score_per_wrong_answer}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Mazzard",
          }}
        >
          {onlyNeedOneButton && (
            <Button
              style={{
                backgroundColor: yellowButtonColor,
                borderColor: yellowButtonColor,
                color: "#272727",
                fontFamily: "Mazzard",
                fontWeight: "600",
              }}
              onClick={startAssessmentPressed || onClose}
            >
              {button1Text}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  } else {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        centered
        contentClassName="common-alert-modal"
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          style={{
            backgroundColor: defaulttitleColor,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60px",
            fontFamily: "Mazzard",
          }}
        >
          <img
  src={ alertType === "error"
    ? crossImg
    : alertType === "confirmation"
    ? confirmImg
    : alertType === "warning"
    ? warningImg
    : alertType === "info"
    ? infoImg
    : successCrossImg}
  alt="cross"
  style={{
    position: "absolute",
    top: "25px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "75px",
    height: "75px",
    objectFit: "contain",
    zIndex: 10,
  }}
  
/>
 <img
    src={closeIcon}
    alt="close"
    onClick={onClose}
    style={{
      position: "absolute",
      right: "15px",
      top: "15px",
      width: "20px",
      height: "20px",
      cursor: "pointer",
    }}
  />
          {/* <Modal.Title style={{ color: "#FFF", textAlign: "center" }}>
            {title}
          </Modal.Title> */}
        </Modal.Header>
        <br></br>
<Modal.Title style={{ color: "#4b4c4e ", textAlign: "center",marginTop:"8px" }}>
            {title}
          </Modal.Title>
        <Modal.Body
          style={{
            display: "flex",
            margin: "0",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "Mazzard",

            textAlign: "center",
          }}
        >

          {assetSrc && <img src={assetSrc} alt="Alert" />}
          <center>
            <div
              style={{
                textAlign: "center",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontFamily: "Mazzard",
                  wordBreak: "break-word",
                  maxWidth: "100%",
                  display: "inline-block",
                }}
              >
                {message}
              </span>
            </div>
          </center>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Mazzard",
          }}
        >
          {onlyNeedOneButton ? (
            <Button
              style={{
                backgroundColor: "transparent",
                border: buttonBorderColor,
                width: "100px ",
                color:"#000000"
              }}
              onClick={btn1onPressed || onClose}
            >
              {button1Text}
            </Button>
          ) : (
            <>
              <Button
                style={{
                backgroundColor: "transparent",
                  border: buttonBorderColor,
                  width: "100px ",
                                  color:"#000000"

                }}
                onClick={btn1onPressed || onClose}
              >
                {button1Text}
              </Button>
              <Button
                style={{
                backgroundColor: "transparent",
                  border: buttonBorderColor,
                  width: "100px ",
                                  color:"#000000"

                }}
                onClick={btn2onPressed || onClose}
              >
                {button2Text}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
};

export default CommonAlert;
